import { marketingUrl } from '@ui/lib/urls'

import { FinanceToolsCategory } from '@website/types'

export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/atm-instant-cash-rewards/id1507829573'
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.atm.atm.prod'
export const APP_STORE_RATING = { rating: '4.7', reviews: '25K' }
export const GOOGLE_PLAY_RATING = { rating: '4.5', reviews: '55K' }
// Marketing-owned, one per download surface so installs attribute to it.
export const BRANCH_DOWNLOAD_LINK = {
  website: 'https://atm.app.link/T7lUHlVg55b',
  postRegistration: 'https://atm.app.link/I6NnC6pg55b',
  dashboard: 'https://atm.app.link/U4OKBYqh55b',
} as const

// Per-click override of the link's desktop fallback; the click still counts.
export function withDesktopStoreFallback({
  link,
  store,
}: {
  link: string
  store: 'appStore' | 'googlePlay'
}) {
  const url = new URL(link)
  url.searchParams.set(
    '$desktop_url',
    store === 'appStore' ? APP_STORE_LINK : GOOGLE_PLAY_LINK,
  )
  return url.toString()
}
export const CUSTOMER_SERVICE_LINK =
  'https://atm.atlassian.net/servicedesk/customer/portals'

export const COMPARISON_LINKS = [
  {
    name: 'Bank Accounts',
    short: 'Banking',
    href: marketingUrl('/compare/bank-account'),
    title: 'Compare Bank Accounts',
    description:
      'Explore top bank account offers with no monthly fees, early direct deposit, and cash back rewards.',
    button: 'Compare Banks',
  },
  {
    name: 'Budgeting Apps',
    short: 'Budgeting',
    href: marketingUrl('/compare/budgeting'),
    title: 'Compare Budgeting Apps',
    description:
      'Simplify your finances with apps that track spending, manage bills, and help you save smarter.',
    button: 'Compare Budgeting',
  },
  {
    name: 'Cash Advances',
    short: 'Cash Advance',
    href: marketingUrl('/compare/cash-advance'),
    title: 'Compare Cash Advances',
    description:
      'Access paycheck advances without interest or credit checks to cover emergency expenses.',
    button: 'Compare Cash Advances',
  },
  {
    name: 'Credit Builder Accounts',
    short: 'Build Credit',
    href: marketingUrl('/compare/credit-builder-account'),
    title: 'Compare Credit Builders',
    description:
      'Improve your credit score while building savings with flexible credit builder accounts.',
    button: 'Compare Credit Builders',
  },
  {
    name: 'Investing Apps',
    short: 'Investing',
    href: marketingUrl('/compare/investing'),
    title: 'Compare Investing Apps',
    description:
      'Grow your wealth with beginner-friendly investing tools or advanced trading platforms.',
    button: 'Compare Investing',
  },
]

// The compare pages' sub-nav, sorted once.
export const COMPARE_NAV_LINKS = [...COMPARISON_LINKS]
  .sort((a, b) => a.short.localeCompare(b.short))
  .map((link) => ({ label: link.short, href: link.href }))

export const FINANCE_TOOLS: {
  name: string
  href: string
  description: string
  category: FinanceToolsCategory
}[] = [
  {
    name: 'Loan Calculator',
    href: '/finance-tools/debt/loan-calculator',
    description:
      'Calculate monthly payments and interest for different loan types.',
    category: 'Debt',
  },
  {
    name: 'Compound Interest Calculator',
    href: '/finance-tools/investment/compound-interest-calculator',
    description:
      'Calculate how investments grow over time with compound interest.',
    category: 'Investment',
  },
  {
    name: 'ROI Calculator',
    href: '/finance-tools/investment/roi-calculator',
    description: 'Calculate the return on investment for different scenarios.',
    category: 'Investment',
  },
  {
    name: 'Inflation Impact Calculator',
    href: '/finance-tools/savings-and-returns/inflation-impact-calculator',
    description:
      'See how inflation affects the future value of money and savings.',
    category: 'Savings and Returns',
  },
]
